import Image from "next/image";
import { PropTypes } from "prop-types";
import PrimaryBtn from "../button/primaryBtn";

function NotFound(props) {
  const {
    imageName = "not-found.png",
    imageHolderClassName = "w-[15.5rem] md:w-[21.25rem] h-[12.375rem] md:h-[16.875rem]",
    wrapperClassName = "",
    heading,
    headingClassName = "text-heading4 text-grayD2",
    bodyText = "",
    bodyClassName = "text-body1",
    btnText = "",
    btnClassName = "",
    onBtnClick,
  } = props;

  return (
    <div className={`table ${wrapperClassName}`}>
      <div className={`mx-auto relative ${imageHolderClassName}`}>
        <Image
          src={`/assets/error-images/${imageName}`}
          alt="not-found-page"
          fill
          className="object-contain"
          sizes="33vw"
        />
      </div>
      <h4 className={`font-semibold text-center ${headingClassName}`}>
        {heading}
      </h4>
      <p className={`text-center ${bodyClassName}`}>{bodyText}</p>

      <div className="flex justify-center">
        <PrimaryBtn
          btnText={btnText}
          className={btnClassName}
          onClick={onBtnClick}
        />
      </div>
    </div>
  );
}

NotFound.propTypes = {
  imageName: PropTypes.string,
  imageHolderClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  heading: PropTypes.string,
  headingClassName: PropTypes.string,
  bodyText: PropTypes.string,
  bodyClassName: PropTypes.string,
  btnText: PropTypes.string,
  btnClassName: PropTypes.string,
  onBtnClick: PropTypes.func,
};

export default NotFound;
